import React, { Component, cloneElement } from 'react';
import { List, CreateButton, RefreshButton, TopToolbar, Datagrid, TextField, DateField, ShowButton, Filter, TextInput, EditButton, ExportButton } from 'react-admin';
// import { DateInput } from 'react-admin-date-inputs';
import { Scrollbars } from 'react-custom-scrollbars';
import { getComplaintTypeChoices, getComplaintStatusChoices, RUN_TIME_API_ENDPOINT, CommonHeaderOption} from '../common/common';
import Modal from 'react-responsive-modal';
import Swal from 'sweetalert2';
import GetAppIcon from '@mui/icons-material/GetApp';

const selectInputStyle = {
    width: 200,
};

const Filters = (props) => (
    <Filter {...props}>
        <TextInput label="Promotion Title" source="title"/>
        {/* <DateInput source="starts_at"  label="Start date"  />
        <DateInput source="ends_at"  label="End date"  /> */}
    </Filter>
);

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const textFieldStyle = {
    display: 'block',
    width: 200,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',

};

// const ListActions = ({ resource, basePath, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters }) => {
//     return (
//         <TopToolbar>
//             {filters && cloneElement(filters, {
//                 resource,
//                 showFilter,
//                 displayedFilters,
//                 filterValues,
//                 context: 'button',
//             })}
//             <CreateButton basePath={basePath} />
//             <RefreshButton />
//         </TopToolbar>
//     )
// }

class ListActions extends Component {
    constructor(props){
      
      super(props);
      this.state = {
        modalShow : false,
        modalMsg : '',
        customFilterUrl : 'filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D',
      }
    }
    
    exporterModal = () => {
      return ''
    }
  
    onClose = () => {
      this.setState({ modalShow: false})
    }
    render(){
      const { resource, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters, basePath } = this.props;
      const csvResource = resource + '_csv'
    return (
      <React.Fragment>
      <TopToolbar>
        {filters && cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
        <RefreshButton />
        <CreateButton basePath={basePath} />
      </TopToolbar>
      {
            this.state.modalShow &&
            <Modal open={this.state.modalShow} onClose={this.onClose} center> 
              <h3>{this.state.modalMsg}</h3>
            </Modal>
      }
      </React.Fragment>
    )
    }
  }

class PromotionNotificationList extends Component {

    render() {
        const { state, props, permissions } = this;
        return (
            <React.Fragment>
                <Scrollbars className="scroll-container" >
                    <List {...props} sort={{ field: 'created_at', order: 'DESC' }}  filters={<Filters />} title="Promotion" bulkActionButtons={false} actions={<ListActions permissions={props} />}>
                        <Datagrid rowClick="show">
                            <EditButton />
                            <TextField label="Promotion Title" source="title" style={textFieldStyle} allowEmpty />
                            <DateField label="Start date" source="starts_at" showTime />
                            <DateField label="End date" source="ends_at" showTime />
                            <DateField source="created_at" showTime />
                            <DateField source="updated_at" showTime />
                            <ShowButton />
                        </Datagrid>
                    </List>
                </Scrollbars>
            </React.Fragment>
        )
    }
}


export default PromotionNotificationList;